export const services={
Icon1 :'/images/csohajlitas-4.jpg',
Icon2 :'/images/elhajlitas_es_lemez_megmunkalas-1.jpg',
Icon3 :'../../images/elektrosztatikus_porszoras.jpg',
 
  
  };